import { AcordoAccordion } from "./components/acordo";
import { ResumoAcordoAccordion } from "./components/resumo";


interface ResumoAcordoAccordionProps {
  formaPag: string;
  vencimento: string;
}

export const ResumoAcordo = ({ formaPag, vencimento }: ResumoAcordoAccordionProps) => {
  return (
    <div>
      <ResumoAcordoAccordion formaPag={formaPag} vencimento={vencimento} />
      <AcordoAccordion />
    </div>
  );
};
